import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Task from './components/Task';
import './App.css';

const statuses = ['To Do', 'In Progress', 'Done'];

// Base API normalisée (accepte REACT_APP_API_URL avec ou sans slash final)
const API_BASE = (process.env.REACT_APP_API_URL || '/api/tasks').replace(/\/+$/, '');
const join = (base, path) => `${base}/${String(path).replace(/^\/+/, '')}`;

function App() {
  const [tasks, setTasks] = useState([]);
  const [newTask, setNewTask] = useState({ title: '', description: '', status: 'To Do' });

  useEffect(() => {
    const fetchTasks = async () => {
      try {
        const { data } = await axios.get(API_BASE);
        setTasks(data);
      } catch (err) {
        console.error('Error fetching tasks:', err);
      }
    };
    fetchTasks();
  }, []);

  const moveTask = async (taskId, direction) => {
    const task = tasks.find((t) => t._id === taskId);
    const idx = statuses.indexOf(task.status);
    const newIdx = idx + direction;
    if (newIdx < 0 || newIdx >= statuses.length) return;

    const updatedTask = { ...task, status: statuses[newIdx] };
    try {
      await axios.put(join(API_BASE, taskId), updatedTask);
      setTasks((prev) => prev.map((t) => (t._id === taskId ? updatedTask : t)));
    } catch (err) {
      console.error('Error updating task:', err);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewTask((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!newTask.title || !newTask.description) return;
    try {
      const { data } = await axios.post(API_BASE, newTask);
      setTasks((prev) => [...prev, data]);
      setNewTask({ title: '', description: '', status: 'To Do' });
    } catch (err) {
      console.error('Error creating task:', err);
    }
  };

  return (
    <div className="App">
      <header className="App-header"><h1>Task Manager</h1></header>
      <main className="kanban">
        {statuses.map((status) => (
          <div key={status} className="kanban-column">
            <h2>{status}</h2>
            {tasks.filter((t) => t.status === status).map((task) => (
              <Task key={task._id} task={task} moveTask={moveTask} />
            ))}
          </div>
        ))}
      </main>
      <div className="task-form">
        <h3>Create New Task</h3>
        <form onSubmit={handleSubmit}>
          <div className="form-field">
            <label>Title</label>
            <input name="title" value={newTask.title} onChange={handleInputChange} placeholder="Task title" required />
          </div>
          <div className="form-field">
            <label>Description</label>
            <textarea name="description" value={newTask.description} onChange={handleInputChange} placeholder="Task description" required />
          </div>
          <div className="form-field">
            <label>Status</label>
            <select name="status" value={newTask.status} onChange={handleInputChange}>
              {statuses.map((s) => <option key={s} value={s}>{s}</option>)}
            </select>
          </div>
          <button type="submit">Create Task</button>
        </form>
      </div>
    </div>
  );
}
export default App;
